import { ActionParams } from '../actions';
import { PageRoute, Pages } from '@src/types';

export const navigateTo = ({ services }: ActionParams) => (page: PageRoute) => {
  services.navigateTo(Pages[page].navigateConfig);
};
